// Import model
import { FilterAiAssistantRequest } from '../models/FilterAiAssistantRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { AiAssistantCondition } from '../models/AiAssistantCondition';
import { AiAssistantFields } from '../models/AiAssistantFields';
import { AiAssistantIndexedFields } from '../models/AiAssistantIndexedFields';

// Import dependency serializers (for complex types)
import { AiAssistantConditionSerializer } from './AiAssistantConditionSerializer';
import { AiAssistantFieldsSerializer } from './AiAssistantFieldsSerializer';
import { AiAssistantIndexedFieldsSerializer } from './AiAssistantIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterAiAssistantRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterAiAssistantRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterAiAssistantRequest instance
   */
  static deserialize(json: string): FilterAiAssistantRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterAiAssistantRequest instance
   */
  static fromObject(obj: any): FilterAiAssistantRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterAiAssistantRequest');
    }


    const instance: FilterAiAssistantRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as AiAssistantIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as AiAssistantFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        AiAssistantConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterAiAssistantRequest instances
   */
  static deserializeArray(json: string): FilterAiAssistantRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterAiAssistantRequest instance to a JSON string
   */
  static serialize(instance: FilterAiAssistantRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterAiAssistantRequest instance to a plain object
   */
  static toObject(instance: FilterAiAssistantRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        AiAssistantConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterAiAssistantRequest instances to a JSON string
   */
  static serializeArray(instances: FilterAiAssistantRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
